import React from "react";

import MessageCard from "../message-cards/index";
import { API } from "@/api/index";
import { Tooltip } from "antd";
/**
 * 解析来源
 * @param _data
 * @returns
 */
export function parseSource(_data, zsk) {
  //downloadfile   1 是开启 0 是不开启
  const getTitle = (num, data, allData) => {
    if (num === 10) {
      return `来源：门户搜索 ${data.length}条`;
    } else if (num === 11) {
      return `来源：站群搜索 ${data.length}条`;
    } else if (num === 12) {
      return `来源：联网检索 ${data.length}条`;
    } else if (num === 1) {
      // if (allData?.knowledge_type && allData?.knowledge_type === "qa_pairs") {
      //     return `来源：问答对【${allData?.knowledge_title}】`
      // }
      return `来源：知识库 ${
        allData?.docs && allData?.docs.length
          ? allData?.docs.length
          : data.length
      }个`;
    } else if (num === 14) {
      if (allData?.knowledge_type && allData?.knowledge_type === "qa_pairs") {
        // return `来源：标注【${allData?.knowledge_title}】`
        return `来源：标注`;
      }
      return `来源：知识库 ${data.length}个`;
    } else if (num === 2) {
      return `来源：数据库`;
    } else if (num === 3) {
      return `来源：技能`;
    } else {
      return "";
    }
  };

  let obj = {};
  if (zsk && zsk.length) {
    for (let i = 0; i < zsk.length; i++) {
      obj[zsk[i].id] = {
        id: zsk[i].id,
        downloadFile: zsk[i].downloadFile,
      };
    }
  }

  if (_data.docs && _data.docs.length) {
    // for (let j = 0; j < zsk.length; j++) {
    //     for (let i = 0; i < _data.docs.length; i++) {

    //         if (_data.docs[i].kb_id) {
    //             if (zsk[j].id === _data.docs[i].kb_id.split("_")[1]) {
    //                 _data.docs[i].downloadFile = zsk[j].downloadFile
    //             }
    //         }

    //     }

    // }
    for (let i = 0; i < _data.docs.length; i++) {
      if (_data.docs[i].kb_id) {
        let did = _data?.docs[i].kb_id.split("_")[1];
        console.log(did, "这是啥");
        if (did && obj[did]?.id === did) {
          _data.docs[i].downloadFile = obj[did].downloadFile;
        }
      }
    }
  }
  console.log("_data,zsk======", _data, zsk, _data.docs, obj);

  const getDocsLink = (data) => {
    if (data[0].url) {
      return {
        title: `【${data[0].name}】`,
        ...data[0],
      };
    } else {
      if (data[0].kb_id) {
        console.log(data[0], "你好呀");
        return {
          title: `【${data[0].name}】`,
          ...data[0],
          url: data[0]?.downloadFile
            ? data[0]?.downloadFile * 1 === 1
              ? data[0].url
                ? data[0].url
                : API.downDocs +
                  `?zskId=${data[0].kb_id}&filename=${encodeURIComponent(
                    data[0].name,
                  )}&qId=${_data.qId}`
              : undefined
            : data[0].url
            ? data[0].url
            : undefined,
        };
      } else {
        return {
          title: `【${data[0].name}】`,
          ...data[0],
        };
      }
    }
  };

  if (_data?.src?.[0].type === 0) {
    return {
      label: "来源：知识库",
      links: _data.docs
        ? _data?.docs.length > 1
          ? _data?.docs?.map((item) => {
              return {
                ...item,
                title: `【${item.name}】`,
                url: undefined,
              };
            })
          : undefined
        : undefined,
      link: _data?.docs?.length === 1 ? getDocsLink(_data.docs) : undefined,
    };
  }

  if (_data?.src?.[0].type === 16) {
    return {
      label: (
        <span
          style={{
            cursor: "pointer",
          }}
          onClick={() => {
            window.openMore();
            window.saveSearch(_data?.query);
          }}
        >
          更多资料
        </span>
      ),
      links: undefined,
      link: undefined,
    };
  }

  if (
    _data?.src?.[0]?.type === 1 ||
    _data?.src?.[0]?.type === 2 ||
    _data?.src?.[0]?.type === 3 ||
    (_data?.src?.[0]?.type === 14 && _data?.src)
  ) {
    return _data?.src && _data?.src.length
      ? {
          label: getTitle(_data?.src?.[0]?.type, _data?.src, _data),
          links: _data?.docs
            ? _data?.docs.length > 1
              ? _data?.docs?.map((item) => {
                  if (item.kb_id) {
                    if (window.canDownLoad) {
                      return {
                        ...item,
                        title: `【${item.name}】`,
                        url: item?.downloadFile
                          ? item?.downloadFile * 1 === 1
                            ? item.url
                              ? item.url
                              : API.downDocs +
                                `?zskId=${
                                  item.kb_id
                                }&filename=${encodeURIComponent(
                                  item.name,
                                )}&qId=${_data.qId}`
                            : undefined
                          : item.url
                          ? item.url
                          : undefined,
                      };
                    } else {
                      if (_data?.src?.[0]?.type === 3) {
                        if (item.content) {
                          return {
                            ...item,
                            title: (
                              <div>
                                <div>{`【${item.name}】`}</div>
                                <div>{item.content.slice(0, 15)}</div>
                              </div>
                            ),
                          };
                        }
                        return {
                          ...item,
                          title: `【${item.name}】`,
                          url: null,
                        };
                      } else {
                        return {
                          ...item,
                          title: `【${item.name}】`,
                          url: item?.downloadFile
                            ? item?.downloadFile * 1 === 1
                              ? item.url
                                ? item.url
                                : API.downDocs +
                                  `?zskId=${
                                    item.kb_id
                                  }&filename=${encodeURIComponent(
                                    item.name,
                                  )}&qId=${_data.qId}`
                              : undefined
                            : item.url
                            ? item.url
                            : undefined,
                        };
                      }
                    }
                  } else {
                    if (window.canDownLoad) {
                      return {
                        title: `【${item.name}】`,
                        ...item,
                      };
                    } else {
                      if (_data?.src?.[0]?.type === 3) {
                        if (item.content) {
                          return {
                            ...item,
                            title: (
                              <Tooltip title={item.name} >
                                <div
                                  style={{
                                    width: "210px",
                                  }}
                                  onClick={() => {
                                    window.openFdText();
                                    window.saveFdText(item.content);
                                    window.saveFdTitle(item.name)
                                  }}
                                >
                                  <div
                                    style={{
                                      width: "100%",
                                      textOverflow: "ellipsis",
                                      overflow: "hidden",
                                      whiteSpace: "nowrap",
                                    }}
                                  >{`[${item.index}]${item.name}`}</div>
                                  <div
                                    style={{
                                      padding: "0 10px",
                                      color: "#AAAAAA",
                                    }}
                                  >
                                    {item.content.slice(0, 15)}
                                  </div>
                                </div>
                              </Tooltip>
                            ),
                            url: null,
                          };
                        }
                        return {
                          ...item,
                          title: `【${item.name}】`,
                          url: null,
                        };
                      } else {
                        return {
                          ...item,
                          title: `【${item.name}】`,
                        };
                      }
                    }
                  }
                })
              : undefined
            : _data?.src.length > 1
            ? _data?.src?.map((item) => {
                return {
                  title: `【${item?.name}】`,
                  url: item?.url,
                };
              })
            : undefined,
          link:
            _data?.docs && _data?.docs?.length === 1
              ? _data?.docs?.length === 1
                ? getDocsLink(_data.docs)
                : undefined
              : _data?.src?.length === 1
              ? _data?.knowledge_type && _data?.knowledge_type === "qa_pairs"
                ? undefined
                : {
                    url: window.canDownLoad ? _data?.src[0].url : undefined,
                    title: `【${_data?.src[0].name}】`,
                  }
              : undefined,
        }
      : undefined;
  }

  if (
    _data?.src?.[0]?.type === 10 ||
    _data?.src?.[0]?.type === 11 ||
    (_data?.src?.[0]?.type === 12 && _data?.search_items)
  ) {
    return _data?.search_items && _data?.search_items.length
      ? {
          label: getTitle(_data?.src?.[0]?.type, _data?.search_items, _data),
          links:
            _data?.search_items.length > 1
              ? _data?.search_items?.map((item) => {
                  return {
                    title: item.title,
                    url: item.url,
                  };
                })
              : undefined,
          link:
            _data?.search_items.length === 1
              ? {
                  url: _data?.search_items[0].url,
                  title: _data?.search_items[0].title,
                }
              : undefined,
        }
      : undefined;
  }
  return _data?.src?.length
    ? {
        links:
          _data?.src?.length > 1
            ? _data?.src?.map((item) => {
                return {
                  title: item?.name,
                  url: item?.url,
                };
              })
            : undefined,
        link:
          _data?.src?.length === 1
            ? {
                url: _data?.src[0].url,
                title: _data?.src[0].name,
              }
            : undefined,
      }
    : undefined;
}

export function parseHtml(msg) {
  return msg && !msg.chat_qa && msg.html && msg.html.length
    ? msg.html
    : undefined;
}

export const isMd = (msg) => {
  if (
    (!msg?.form || msg.form?.type !== "link") &&
    msg?.answer &&
    msg?.answer !== ""
  ) {
    return true;
  }
  return false;
};

export const isIframe = (msg) => {
  console.log(msg, "判断是否是iframe");
  if (msg && msg?.form && msg?.form?.type === "link") {
    return true;
  }
  return false;
};

export const parseContent = (msg) => {
  console.log(msg, "返回来的ws数据");
  // if (msg?.answer.includes("<｜end▁of▁sentence｜>")) {
  //   msg?.answer.replace("<｜end▁of▁sentence｜>", "")
  // }
  return isMd(msg)
    ? // <iframe name='aa' src="http://localhost:3001/" ></iframe>
      (msg?.answer?.includes("<｜end▁of▁sentence｜>")
        ? msg?.answer?.replace("<｜end▁of▁sentence｜>", "")
        : msg?.answer +
          `${
            window.fixApply && msg.isFinished
              ? `${window.fixApplyTetx || ""}`
              : ""
          }`) || ""
      // (msg?.answer?.includes("<｜end▁of▁sentence｜>")
      //   ? msg?.answer?.replace("<｜end▁of▁sentence｜>", "")
      //   : `<gbichat title='本科生就业率各年份统计如下'  attributionable="true" interpretationable="true"  forecastable="true"  default_chart="line" >你好啊</gbichat>`) || ""
    : "";
  // <MessageCard msgId={msg?.qId} {...msg} />
};

export const parseExtra = (msg) => {
  return <MessageCard msgId={msg?.qId} {...msg} />;
};

export const parseSrcs = (_data) => {
  if (isIframe(_data)) {
    return {
      src: _data?.form?.url,
      name: _data?.qId,
      defaultHeight: _data?.form?.height,
    };
  }
  return undefined;
};
